export const sendAdminMessageApiCall = (ajax, data, history) => {
  ajax.post(
    "adminMessages/create",
    JSON.stringify(data),
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    },
    () => {
      history.push("/adminMessages/list");
    }
  );
};

export const adminMessageChannelsEnum = {
  SMS: 1,
  Email: 2,
  PushNotification: 4,
};
